export const isWebexContext = () => window.location.pathname.includes('webex');
